import React, { useEffect, useState } from "react";
import { Modal, Form, Row, Col, Input, Select, message } from "antd";
import { FormComponentProps } from "antd/lib/form";
import { IRequirement, IRequirementType } from "./types";
import { saveOrUpdate, select } from "../actions/dimensionsAndType";
import { Utilitaries } from "../../../business";
const { Option } = Select;

interface IProps extends FormComponentProps {
    record?: IRequirement;
    onClose: (reload?: boolean) => void;
}

function FormRequirement({ onClose, record, form }: IProps) {
    const [isSaving, setIsSaving] = useState(false);
    const [requirementTypeList, setRequirementTypeList] = useState<IRequirementType[]>([]);
    const [loadingTypes, setLoadingTypes] = useState(true);

    useEffect(() => {
        select({
            accao: "lista",
            lista: "tipos_requisitos",
            pagina: 1,
            resultados_pagina: 0,
        })
            .then((response) => {
                const list: IRequirementType[] = Utilitaries.toArray(response.linha);
                const data = list.map((item) => ({
                    ...item,
                    designacao: typeof item.designacao === "object" ? "" : item.designacao,
                    descricao: typeof item.descricao === "object" ? "" : item.descricao,
                }));
                setRequirementTypeList(data);
                setLoadingTypes(false);
            })
            .catch(() => {
                message.error("Erro ao carregar os tipos de requisitos");
                onClose();
            });
    }, [onClose]);

    function handleOk() {
        form.validateFields((err, values) => {
            console.log("values", values);
            if (!err) {
                setIsSaving(true);

                const objToSave = record
                    ? {
                          id_requisito: record.id_requisito,
                          activo: true,
                          versao: record.versao !== "" ? record.versao + 1 : 1,
                      }
                    : {
                          versao: 1,
                      };

                const data = JSON.stringify({
                    requisito: {
                        ...values,
                        ...objToSave,
                        activo: true,
                    },
                });

                saveOrUpdate({
                    accao: "guardar",
                    formulario: "qa_requisitos.xml",
                    dados: data,
                })
                    .then((sucess) => {
                        if (sucess) {
                            message.success("Guardado");
                            onClose(true);
                        } else {
                            message.error("Ocorreu um erro");
                            setIsSaving(false);
                        }
                    })
                    .catch(() => {
                        message.error("Ocorreu um erro");
                        setIsSaving(false);
                    });
            }
        });
    }

    const { getFieldDecorator } = form;
    const title = record ? "Editar requisito" : "Nova requisito";
    return (
        <Modal title={title} visible onCancel={() => onClose()} onOk={handleOk} width="50%" confirmLoading={isSaving}>
            <Form layout="vertical">
                <Row gutter={18}>
                    <Col xs={24} sm={24} md={24}>
                        <Form.Item label="Tipo de requisito">
                            {getFieldDecorator("tipo_requisito", {
                                initialValue: record?.id_tipo_requisito,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório",
                                    },
                                ],
                            })(
                                <Select
                                    showSearch
                                    allowClear
                                    loading={loadingTypes}
                                    optionFilterProp="children"
                                    filterOption={(input, option) => {
                                        if (option.props.children === undefined || option.props.children === null) {
                                            return false;
                                        }

                                        return (
                                            option.props.children
                                                .toString()
                                                ?.toLowerCase()
                                                .indexOf(input.toLowerCase()) >= 0
                                        );
                                    }}
                                >
                                    {requirementTypeList.map((item) => (
                                        <Option key={item.id_tipo_requisito}>{item.designacao}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24}>
                        <Form.Item label="Requisito">
                            {getFieldDecorator("designacao", {
                                initialValue: record?.designacao,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório",
                                    },
                                ],
                            })(<Input />)}
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
}

export const WrappedFormRequirement = Form.create<IProps>({
    name: "form_requirement",
})(FormRequirement);
